import { LanguageResourceKey } from "PFCore/i18n/resources";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useLanguageLabelMap = () => {
  const { t: tLocales } = useTranslation("locales");

  return useMemo(
    () => ({
      [LanguageResourceKey.en]: tLocales("en"),
      [LanguageResourceKey.frCA]: tLocales("frCA"),
      [LanguageResourceKey.frFR]: tLocales("frFR"),
      [LanguageResourceKey.esES]: tLocales("esES"),
      [LanguageResourceKey.noNO]: tLocales("noNO"),
      [LanguageResourceKey.ptPT]: tLocales("ptPT"),
      [LanguageResourceKey.svSE]: tLocales("svSE"),
      [LanguageResourceKey.deDE]: tLocales("deDE"),
      [LanguageResourceKey.fiFI]: tLocales("fiFI"),
      [LanguageResourceKey.daDK]: tLocales("daDK"),
      [LanguageResourceKey.jaJP]: tLocales("jaJP")
    }),
    [tLocales]
  );
};
